export default "__VITE_ASSET__BjIpvZjA__"